const PAYSLIP_ENDPOINTS = {
  /**
   * Payslips (bulletins) for a given employee.
   * GET /employees/:employeeId/payslips  →  { data: Payslip[], meta: {...} }
   */
  LIST: (employeeId: string) => `/employees/${employeeId}/payslips`,
  /**
   * One payslip detail (frozen header + rubrique lines).
   * GET /employees/:employeeId/payslips/:payslipId  →  { header, lines }
   */
  DETAIL: (employeeId: string, payslipId: string) =>
    `/employees/${employeeId}/payslips/${payslipId}`,
  PARAMS: {
    SORT_BY: 'sortBy',
    SORT_ORDER: 'sortOrder',
    PAGE: 'page',
    LIMIT: 'limit',
  },
};

export default PAYSLIP_ENDPOINTS;
